import { ROLES_CONST } from 'configs/localData/permissions';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentRole } from 'redux/auth/selectors';
import { checkRole } from 'utils/tools';

const useCheckJobListingPermission = () => {
  const currentRole = useSelector(getCurrentRole);

  const canModifyJobListing = useMemo(
    () =>
      checkRole(
        [
          ROLES_CONST.companyAdmin,
          ROLES_CONST.companyStaff,
          ROLES_CONST.providerAdmin,
          ROLES_CONST.centreAdmin,
        ],
        currentRole,
      ),
    [currentRole],
  );

  const canModifyCampaign = useMemo(
    () =>
      checkRole(
        [ROLES_CONST.companyAdmin, ROLES_CONST.companyStaff],
        currentRole,
      ),
    [currentRole],
  );

  return {
    canModifyJobListing,
    canModifyCampaign,
  };
};

export default useCheckJobListingPermission;
